import { Periood } from "./Periood";

export class MinuAmetnik {
    public ametnik: Ametnik | undefined = undefined;
    public ametnikuAsendaja: Ametnik | undefined = undefined;
    public asendamisePeriood: Periood | undefined = undefined;
}

export class Ametnik {
    public taisNimi: string | undefined = undefined;
    public email: string | undefined = undefined;
    public telefon: string | undefined = undefined;
}
